import { render, staticRenderFns } from "./associate-overview.vue?vue&type=template&id=025c8b4c"
import script from "./associate-overview.vue?vue&type=script&lang=js"
export * from "./associate-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports